import { InstantMetaGameType } from '../state/metaGames.types';
import { useSelector } from '@bonanza-social/toolkit/state';
import { selectMetaGameCount, selectMetaGamesCountDataState } from '../state';
import useLaunchMetaGame from './useLaunchMetaGame';

const useInstantMetaGame = (gameType: InstantMetaGameType) => {
  const metaGameCount = useSelector((state) =>
    selectMetaGameCount(state, gameType),
  );
  const metaGameCountDataState = useSelector(selectMetaGamesCountDataState);
  const launchMetaGame = useLaunchMetaGame(gameType);

  return {
    metaGameCount,
    metaGameCountDataState,
    launchMetaGame,
  };
};

export default useInstantMetaGame;
